import React, {useState} from "react";
import cabinetStyle from "./MentorCabinet.module.css";
import Style from "../Style.module.css";
import {Badge} from "react-bootstrap";
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import EditComponent from "./EditComponent";
import * as UserService from "../../api/UserService";
import EditGroupGameModalWindow from "./EditGroupGameModalWindow";
import GroupGamesListRowDetails from "./GroupGamesListRowDetails";
import DialogComponent from "../DialogComponent";
import * as GroupGameService from "../../api/GroupGameService";
import DeleteComponent from "./DeleteComponent";
import PayButtonComponent from "./PayButtonComponent";
import DeleteComponentDisabled from "./DeleteComponentDisabled";
import PayGameModal from "./PayGameModal";
import * as PaymentService from "../../api/PaymentsService";
import {trySetTimeout} from "../../hooks/trySetTiemout";
import {useTranslation} from "react-i18next";
import {useEffectOnce} from "../../hooks/useEffectOnce";

function GroupGamesListRow(props) {
    const [editable, setEditable] = useState(false)
    const [description, setDescription] = useState(props.description)
    const [mentorVideos, setMentorVideos] = useState([])
    const [playerVideos, setPlayerVideos] = useState([])
    const [deleteModalOpened, setDeleteModalOpened] = useState(false)
    const [paymentModalOpened, setPaymentModalOpened] = useState(false)
    const [disablePayButtons, setDisablePayButtons] = useState(false)
    const [successPayment, setSuccessPayment] = useState(undefined)
    const [gamePrice, setGamePrice] = useState(undefined)
    const { t } = useTranslation('translation', { keyPrefix: 'gamesListPage' });

    function openDescriptionAndPullRecordings(event) {
        getProcessedRecordings()
        openDescription(event)
    }

    useEffectOnce(() => {
        if (props.description) {
            getProcessedRecordings()
        }
    })

    function openDescription(event) {
        if (description === true) {
            setDescription(false)
        } else {
            setDescription(true)
        }
        if (event.stopPropagation) event.stopPropagation();
    }

    function openEditGameModal(event) {

        setEditable(true)
        event.cancelBubble = true;
        if (event.stopPropagation) event.stopPropagation();
    }

    function openDeleteModal(event) {

        setDeleteModalOpened(true)
        event.cancelBubble = true;
        if (event.stopPropagation) event.stopPropagation();
    }

    function closeEditGameModal() {
        setEditable(false)
    }

    function openTheGame() {
        window.open('/groupgame/' + props.game.id, '_blank')
    }

    function prepProcessedVideos(videos) {
        let mentor = []
        let player = []

        videos.forEach(
            video => {
                if (video["user"] === "mentor") {
                    mentor.push(video)
                } else {
                    player.push(video)
                }
            }
        )
        setMentorVideos(mentor)
        player.sort((a, b) => a.user > b.user ? 1 : -1)
        setPlayerVideos(player)
    }

    function getProcessedRecordings() {
        if (props.game.recording_status === "processed") {
            UserService.getGroupGameProcessedRecordings(props.game.id, prepProcessedVideos, () => {
            })
        }
    }

    function deleteGame() {
        GroupGameService.deleteGroupGame(props.game.id, () => {
            props.updateGames()
            props.updateBalance()
            setDeleteModalOpened(false)
        }, () => {
        })
    }

    function openPaymentModal(event) {
        PaymentService.getGameRemainingPrice(props.game.id, (jres) => {
            setGamePrice(jres.remaining)
            setPaymentModalOpened(true)
        }, () => {
        })
        event.cancelBubble = true;
        if (event.stopPropagation) event.stopPropagation();
    }

    function closePaymentModal() {
        setPaymentModalOpened(false)
    }

    function pay() {
        setDisablePayButtons(true)
        PaymentService.payGame(
            props.game.id,
            () => {
                setSuccessPayment(true)
                trySetTimeout(() => {
                    setDisablePayButtons(false)
                    setPaymentModalOpened(false)
                    setSuccessPayment(undefined)
                }, 1000)
                props.updateGames()
                props.updateBalance()
            },
            () => {
                window.alert("Payment failed")
            }
        )
    }

    return (
        <>
            <div className={description
                ? `${cabinetStyle.gameListRowNewContainer} ${cabinetStyle.commonTileExtended}`
                : `${cabinetStyle.gameListRowNewContainer} ${cabinetStyle.commonTile}`}>
                <div
                    className={!props.game.require_payment ? cabinetStyle.gameListRowTwoControls : cabinetStyle.gameListRowThreeControls}
                    onClick={openTheGame}>
                    <div className={Style.h5Heading}>
                        <div>
                            <FiberManualRecordIcon
                                style={{fontSize: "small"}}
                                sx={props.game.players?.filter(player => !player.is_over)?.length === 0
                                    ? {color: '#EBE5FC'} : {color: '#28A745'}}
                            ></FiberManualRecordIcon>
                            <span style={{marginLeft: "7px"}}>
                                {props.game.is_trial_game &&
                                    <Badge bg="secondary" style={{
                                        maxWidth: "50px",
                                        fontSize: "xx-small",
                                        marginRight: "12px"
                                    }}>{t('trialGame')}</Badge>}
                                {props.game.name}
                            </span>
                        </div>

                    </div>
                    {props.game.require_payment &&
                        <PayButtonComponent toolTipText={t('payTheGame')}
                                            openOnClick={openPaymentModal}></PayButtonComponent>
                    }
                    <EditComponent toolTipText={t('editGame')} openOnClick={openEditGameModal}></EditComponent>
                    {(!props.game.is_started || props.game.is_trial_game) &&
                        <DeleteComponent toolTipText={t('deleteGame')} openOnClick={openDeleteModal}></DeleteComponent>}
                    {(props.game.is_started && !props.game.is_trial_game) &&
                        <DeleteComponentDisabled toolTipText={t('gameInProgress')}></DeleteComponentDisabled>
                    }
                </div>
                <div className={cabinetStyle.gameDetailsIcon} onClick={openDescriptionAndPullRecordings}>
                    {description
                        ? <KeyboardArrowUpIcon/>
                        : <KeyboardArrowDownOutlinedIcon/>}
                </div>

                {
                    description &&
                    <GroupGamesListRowDetails
                        game={props.game}
                        players={props.game.players}
                        mentorVideos={mentorVideos}
                        playerVideos={playerVideos}/>
                }
            </div>
            {editable && <EditGroupGameModalWindow onClose={closeEditGameModal}
                                                   gameName={props.game.name}
                                                   players={props.game.players}
                                                   isTrial={props.game.is_trial_game}
                                                   gameId={props.game.id}
                                                   premiumVideo={props.game.premium_video}
                                                   selectedStyle={props.game.game_field_style}
                                                   selectedDeckId={props.game.deck_id}
                                                   selectedDeckType={props.game.deck_type}
                                                   updateGames={props.updateGames}
                                                   freeTier={props.freeTier}
                                                   currentBalance={props.currentBalance}
                                                   updateBalance={props.updateBalance}
                                                   require_payment={props.game.require_payment}
                                                   videoAllowed={props.game.video_allowed}
            />}
            {deleteModalOpened && <DialogComponent
                onClose={() => {
                    setDeleteModalOpened(false)
                }}
                onConfirm={deleteGame}
                title={t('deleteGame') + " " + props.game.name}
            ></DialogComponent>}
            {paymentModalOpened &&
                <PayGameModal onClose={closePaymentModal}
                              onConfirm={pay}
                              price={gamePrice}
                              game_name={props.game.name}
                              disableControls={disablePayButtons}
                              successPayment={successPayment}
                ></PayGameModal>
            }
        </>

    )

}

export default GroupGamesListRow;